/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { parseDependencies } from './dependenciesParse.generated.js';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  parseDependencies,
  createParserClass
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesParserClass.generated.js
// module id = null
// module chunks = 